export class UserSimpleListReq {
  userName: string | undefined = undefined;
  realName: string | undefined = undefined;
  ids: string[] | undefined = undefined;
  limit: number | undefined = undefined;
	activatedStatus: number | undefined = undefined;
	onJob: boolean | undefined = undefined;
	status: number | undefined = undefined;
	staffType:string = 'no_type';
  projectId:string = '';
}

class UserSimpleRecord {
  tenantUserId: number = 0;
  tenantUserName: string = "";
}

export class UserSimpleListResp {
  records: UserSimpleRecord[] = [];
}
